export default {"src":"/_next/static/media/0x92d6c1e31e14520e676a687f0a93788b716beff5.5bb85d18.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};